/* generated using openapi-typescript-codegen -- do not edit */
/* istanbul ignore file */
/* tslint:disable */
/* eslint-disable */
import type { Service_Input } from '../models/Service_Input';
import type { Service_Output } from '../models/Service_Output';
import type { CancelablePromise } from '../core/CancelablePromise';
import { OpenAPI } from '../core/OpenAPI';
import { request as __request } from '../core/request';
export class ServicesService {
    /**
     * Get Services
     * Get all services. By default, only returns active services.
     * @returns Service_Output Successful Response
     * @throws ApiError
     */
    public static getServicesApiServicesGet({
        activeOnly = true,
    }: {
        activeOnly?: boolean,
    }): CancelablePromise<Array<Service_Output>> {
        return __request(OpenAPI, {
            method: 'GET',
            url: '/api/services/',
            query: {
                'active_only': activeOnly,
            },
            errors: {
                422: `Validation Error`,
            },
        });
    }
    /**
     * Create Service
     * Create a new service.
     * @returns Service_Output Successful Response
     * @throws ApiError
     */
    public static createServiceApiServicesPost({
        requestBody,
    }: {
        requestBody: Service_Input,
    }): CancelablePromise<Service_Output> {
        return __request(OpenAPI, {
            method: 'POST',
            url: '/api/services/',
            body: requestBody,
            mediaType: 'application/json',
            errors: {
                422: `Validation Error`,
            },
        });
    }
    /**
     * Get Service
     * Get a single service by ID.
     * @returns Service_Output Successful Response
     * @throws ApiError
     */
    public static getServiceApiServicesServiceIdGet({
        serviceId,
    }: {
        serviceId: number,
    }): CancelablePromise<Service_Output> {
        return __request(OpenAPI, {
            method: 'GET',
            url: '/api/services/{service_id}',
            path: {
                'service_id': serviceId,
            },
            errors: {
                422: `Validation Error`,
            },
        });
    }
    /**
     * Update Service
     * Update an existing service.
     * @returns Service_Output Successful Response
     * @throws ApiError
     */
    public static updateServiceApiServicesServiceIdPut({
        serviceId,
        requestBody,
    }: {
        serviceId: number,
        requestBody: Service_Input,
    }): CancelablePromise<Service_Output> {
        return __request(OpenAPI, {
            method: 'PUT',
            url: '/api/services/{service_id}',
            path: {
                'service_id': serviceId,
            },
            body: requestBody,
            mediaType: 'application/json',
            errors: {
                422: `Validation Error`,
            },
        });
    }
    /**
     * Delete Service
     * Soft delete a service (marks as inactive).
     * @returns any Successful Response
     * @throws ApiError
     */
    public static deleteServiceApiServicesServiceIdDelete({
        serviceId,
    }: {
        serviceId: number,
    }): CancelablePromise<any> {
        return __request(OpenAPI, {
            method: 'DELETE',
            url: '/api/services/{service_id}',
            path: {
                'service_id': serviceId,
            },
            errors: {
                422: `Validation Error`,
            },
        });
    }
}
